<template>
    <section>
        <Modal @close="$emit('close')">
            <div class="pt-6 px-4 pb-4">
                <h2
                    class="text-brand-neutral-7 text-base font-bold text-center mb-4"
                >
                    Você atingiu o limite do plano "{{
                        plan.name[UserLanguages.PT_BR]
                    }}" 😱
                </h2>
                <p class="text-brand-neutral-5 text-sm text-center mb-6">
                    Você atingiu o limite máximo, mas não se preocupe, pois
                    encontramos o plano ideal para você.
                </p>
                <SubscriptionPlanCard
                    class="mb-8"
                    :title="nextUpgrade.name[UserLanguages.PT_BR]"
                    :price="nextUpgradePrice"
                    :features="nextUpgradeFeatures"
                    icon="/icons/subscriptions/free.svg"
                    featured
                    ctaTitle="Assinar"
                    @click="onSubscribePlan"
                />
                <Button @click="isPlansModalOpen = true"
                    >Ver todos os planos</Button
                >
            </div>
        </Modal>
        <PlansModal v-if="isPlansModalOpen" @close="isPlansModalOpen = false" />
    </section>
</template>
<script setup lang="ts">
const nextUpgrade: IPlan = await useApi("/subscriptions/next-upgrade");
const nextUpgradePrice = nextUpgrade.prices.find(
    (price) => price.currency === "brl" && price.interval === "yearly"
)?.price!;
const nextUpgradeFeatures = nextUpgrade.features.map(
    (feature) => feature[UserLanguages.PT_BR]
);
const isPlansModalOpen = ref(false);

const { plan } = defineProps<{
    plan: IPlan;
}>();

const route = useRoute();
const { $api } = useNuxtApp();

const onSubscribePlan = async () => {
    try {
        const checkoutRes = await $api(
            "/payments/stripe/create-subscription-checkout-session",
            {
                method: "POST",
                body: {
                    planId: nextUpgrade._id,
                    interval: "yearly",
                },
            }
        );

        await navigateTo(
            `/account/checkout?clientSecret=${checkoutRes.clientSecret}&redirectTo=${route.path}`
        );
    } catch (error) {
        /**
         * @todo Log error to sentry
         */
        console.error(error);
    }
};
</script>
